/* eslint-disable */
export default {
  participants: 'Participants',
  host: '(Animateur)',
  removeParticipant: 'Retirer le participant',
  removeTitle: 'Retirer le participant',
  removeDescription: 'Retirer {name} de cette conférence?',
  confirmButtonText: 'Retirer',
  cancelButtonText: 'Annuler',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
